export default "__VITE_ASSET__CUgIDpPp__"